import React, { useEffect, useState } from 'react';
import "./UserControl.css";
import ExecuteAxios from "../../../../Components/ExecuteAxios/ExecuteAxios";
import Panel from 'Components/Panel/Panel';
import AutomaticallyListedAttributes from 'Components/AutomaticallyListedAttributes/AutomaticallyListedAttributes';
import ApplyAttributes from 'Components/ApplyAttributes/ApplyAttributes';
import LoadingIndicator from 'Components/LoadingIndicator/LoadingIndicator';

const UserControl = ({
    onUpdateResetUserList,
    onUpdateUserSelected,
    usersSelected
}) => {
    const [userId, setUserId] = useState([])
    const [nameUser, setNameUser] = useState([])
    const [emailUser, setEmailUser] = useState([])
    const [usernameUser, setUsernameUser] = useState([])
    const [establishmentUser, setEstablishmentUser] = useState([])
    const [username, setUsername] = useState([]);
    const [updateDate, setUpdateDate] = useState(null);
    const [isActive, setIsActive] = useState('S');
    const [isAllowUserLogIn, setIsAllowUserLogIn] = useState('N')

    const [inserting, setInserting] = useState(false)
    const [updating, setUpdating] = useState(false)
    const [userControlList, setUserControlList] = useState(null);
    const [loadingUserPanel, setLoadingUserPanel] = useState(null);

    const attributeList = [
        { name: "id", value: userId, setter: setUserId },
        { name: "name", value: nameUser, setter: setNameUser },
        { name: "email", value: emailUser, setter: setEmailUser },
        { name: "username", value: usernameUser, setter: setUsernameUser },
        { name: "isAllowUserLogIn", value: isAllowUserLogIn, setter: setIsAllowUserLogIn, columnType: 'checkbox' },
        { name: "establishment", value: establishmentUser, setter: setEstablishmentUser },
        { name: "isActive", value: isActive, setter: setIsActive, columnType: 'checkbox' },
        { name: "userLogged", value: username, setter: setUsername },
        { name: "dtUpdate", value: updateDate, setter: setUpdateDate }
    ];

    const callToSetUserControlList = async (userId) => {
        const parameters = { id: userId }
        const user = await ExecuteAxios.api('get', `/user/`, { params: parameters })
        if (user) {
            setUserControlList(user)
            ApplyAttributes.applyAttributes(user, attributeList, userId)
        }
        if (!userId || userId.length === 0) {
            cleanValuesAtributtes();
        }
    };

    useEffect(() => {
        if (updating || usersSelected.length === 1) {
            callToSetUserControlList(usersSelected[0]);
        } else {
            cleanValuesAtributtes()
        }
    }, [inserting, updating]);

    useEffect(() => {
        setUpdating(false)
        if (usersSelected.length === 1) {
            setInserting(false)
            callToSetUserControlList(usersSelected[0]);
        } else {
            callToSetUserControlList();
        }
    }, [usersSelected]);

    function cleanValuesAtributtes() {
        setUserId('');
        setNameUser('')
        setEmailUser('')
        setUsernameUser('')
        setEstablishmentUser('')
        setIsActive('S')
        setIsAllowUserLogIn('N')
        setUsername('')
        setUpdateDate('')
    }

    const readOnlyAttributes = !(inserting || updating);

    async function postUserControl() {
        try {
            setLoadingUserPanel(true)
            cleanValuesAtributtes()
            setInserting(false)
            const response = await ExecuteAxios.api('post', '/user/',
                {
                    username: usernameUser,
                    email: emailUser,
                    name: nameUser,
                    establishment: establishmentUser,
                    isActive: isActive,
                    isAllowUserLogIn: isAllowUserLogIn,
                    role: 'N'
                });

            if (response) {
                onUpdateResetUserList(true)
            }

            return response
        } finally {
            setLoadingUserPanel(false)
        }
    }

    async function putUserControl() {
        try {
            setLoadingUserPanel(true)
            const response = await ExecuteAxios.api('put', '/user/',
                {
                    id: userId,
                    username: usernameUser,
                    email: emailUser,
                    name: nameUser,
                    isActive: isActive,
                    isAllowUserLogIn: isAllowUserLogIn
                });

                if (response) {
                    onUpdateResetUserList(true);
                }
    
                return response;
        } finally {
            setLoadingUserPanel(false)
        }
    }

    const userControlPanelStyle = {
        display: 'flex',
        flexDirection: 'column',
        borderBottom: '2px solid #ccc',
        width: '100%',
        height: '100%'
    };

    return (
        <>
            <LoadingIndicator loaded={!loadingUserPanel}>
                <Panel style={userControlPanelStyle}
                    setUpdating={setUpdating}
                    setInserting={setInserting}
                    inserting={inserting}
                    updating={updating}
                    enableEdit={true}
                    canEdit={usersSelected.length === 1}
                    putFunction={putUserControl}
                    enableNewRecord={true}
                    canNewRecord={true}
                    postFunction={postUserControl}
                    canViewCRUD={true}
                    readOnly={false}
                    recordsSelected={usersSelected}
                    viewOnlyOneRecordCRUD={true}
                    resetVariables={cleanValuesAtributtes}
                    setHigherRegisterSelected={onUpdateUserSelected}
                    resetHigherRegisterInserting={true}
                    dataListedAttributes={userControlList}
                    attributeList={attributeList}
                    onUpdateIdSelected={onUpdateUserSelected}
                >
                    <>
                        <AutomaticallyListedAttributes
                            list={userControlList}
                            attributeList={attributeList}
                            readOnlyAttributes={readOnlyAttributes}
                        />
                    </>
                </Panel>
            </LoadingIndicator>
        </>
    );
};

export default UserControl
